import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';
import type { DeploymentARI } from '../../common/types';

export type State = {
	selectedDeploymentId: DeploymentARI | null;
};

export const initialState: State = {
	selectedDeploymentId: null,
};

export const actions = {
	setSelectedDeploymentId:
		(deploymentId: DeploymentARI | null): Action<State> =>
		({ setState }) =>
			setState({
				selectedDeploymentId: deploymentId,
			}),
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'selectedDeploymentId',
	initialState,
	actions,
});

export const useSelectedDeploymentId = createHook(Store, {
	selector: (state) => state.selectedDeploymentId,
});

export const useSelectedDeploymentActions = createHook(Store, {
	selector: () => null,
});
